export const ROUTE_PATHS = {
  // auth
  login: '/login',
  forgetPassword: '/forget-password',
  tempPassword: '/temporary-password',
  changePassword: '/change-password',
  // admins
  admins: '/admins',
  addAdmin: '/admins/add',
  editAdmin: '/admins/:id/edit',
  // categories
  serviceProviderCategories: '/service-provider-categories',
  viewServiceProviderCategories: '/service-provider-categories/:id',
  addServiceProviderCategories: '/service-provider-categories/add',
  editServiceProviderCategories: '/service-provider-categories/:id/edit',
  // specialties
  specialties: '/specialties',
  viewSpecialties: '/specialties/:id',
  addSpecialties: '/specialties/add',
  editSpecialties: '/specialties/:id/edit',
  // services
  services: '/services',
  addServices: '/services/add',
  editServices: '/services/:id/edit',
  //lookups requests
  lookupsRequests:'/lookups-requests',
  // providers
  serviceProviders: '/service-providers',
  viewServiceProvider: '/service-providers/:id',
  addServiceProvider: '/service-providers/add',
  editServiceProvider: '/service-providers/:id/edit',
  // branches
  branches: '/branches',
  viewBranch: '/branches/:id',
  addProvidersBranch: '/service-providers/:providerid/add-branch',
  editProvidersBranch: '/branches/:branchid/edit-branch/:providerid',
  addProvidersBranchSupportedRegions: '/branches/:providerid/add-edit-branch/coverage-regions',
  addProvidersBranchBranchLocation: '/branches/:providerid/add-edit-branch/branch-location',
  // bookings
  bookings: '/bookings',
  viewBooking: '/bookings/:id',
  addAnotherServices: '/bookings/:id/add-another-service',
  // settings
  settings: '/settings',
  cancellationPolicy: '/settings/cancellation-policy',
  editCancellationPolicy: '/settings/cancellation-policy/edit',
  changePasswordFromSettings: '/settings/change-password',
  mimarConstants: '/settings/mimar-constants',
  editMimarConstants: '/settings/mimar-constants/edit',
  //publish requests
  publishRequests: '/publish-requests',
  viewPublishRequest: '/publish-requests/:id',
  // employees
  employees: '/employees',
  viewEmployee: '/employees/:id',
  editEmployees: '/employees/:id/edit',
  // customers
  customers: '/customers',
  viewCustomer: '/customers/:id',
  // notification
  notifications: '/notifications',
  //transactions
  transactions: "/payment-transactions",
  mimarProfit: "/mimar-profit",
  //providers outstanding balance
  settlements: "/settlements",
  viewSettlement: "/settlements/:id"
};
